export const ENABLE_AMENDMENT_AI_SLIDE_OUT = 'enable-amendment-ai-slide-out';
export const ENABLE_AMENDMENT_V2_JOURNEY = 'enable-llc-amendment-v2-journey';
export const ENABLE_ANNUAL_REPORT_V2_JOURNEY = 'enable-llc-annual-report-v-2-journey';
export const ENABLE_BNPL_R2_FAILED_PAYMENT_RECOVERY = 'enable-bnpl-r2-failed-payment-recovery';
export const BNPL_R2_FAILED_PAYMENT_RECOVERY_EXPERIMENT_NAME = 'bnpl_r2_failed_payment_recovery';
export const ENABLE_CA_FILING_ACCESS_BANNER = 'enable-ca-filing-access-banner';
export const ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES = 'enable-dashboard-link-to-manage-cookies';
export const ENABLE_DASHBOARD_SUBSCRIPTION_DNR = 'enable-dashboard-subscription-dnr';
export const ENABLE_DASHBOARD_SUBSCRIPTION_RESTART = 'enable-dashboard-subscription-restart';
export const ENABLE_EIN_STANDALONE_COUPON = 'enable-ein-standalone-coupon';
export const ENABLE_FUNDBOX_QUALIFIED_LIST_CONTROL = 'enable-fundbox-qualified-list-control';
export const ENABLE_HOLIDAY_BANNER = 'enable-holiday-banner';
export const ENABLE_INVOICE_PAYMENT_PAGE = 'enable-invoice-payment-page';
export const ENABLE_M2A = 'enable-m2a';
export const ENABLE_ORDER_TRACKER_RA_IR = 'enable-order-tracker-ra-ir';
export const ENABLE_ENTERPRISE_DASHBOARD = 'enable-partner-dashboard';
export const ENABLE_PRODUCT_LANDING_PERSONALIZATION = 'enable-product-landing-personalization';
export const ENABLE_SALES_TAX_PRODUCT = 'enable-sales-tax-product';
export const ENABLE_SCORP_BUNDLE_V1 = 'enable-s-corp-bundle-v-1';
export const ENABLE_VELO_ASSISTANT = 'enable-velo-assistant';
export const ENABLE_ZB_BANKING_SUNSET_PH1 = 'zb-banking-sunset-ph1';
export const ENABLE_ZB_BANKING_SUNSET_PH3 = 'zb-banking-sunset-ph3';
export const ENABLE_ZB_BANKING_SUNSET_PH3_HIGH_RISK_CUSTOMERS = 'zb-banking-sunset-ph3-high-risk-customers';
// Same flag key as journeys-api's LAUNCH_DARKLY_FLAGS.V4_SERVICES (server/utils/constants.js)
// and journeys-ui's useJourneyVersion.js — the { [jurisdiction]: [serviceName, ...] } v4
// allowlist. Checked here purely client-side, to skip sending a business entity down the v4
// discovery route for a service/jurisdiction pair journeys-api wouldn't actually serve as v4.
export const JOURNEYS_API_V4_SERVICES = 'journeys-api-v4-services';
// Independent rollout gate for OrderTracker's "LLC Annual Report" link specifically — lets
// this one redirect change ship/roll back on its own schedule, decoupled from the broader
// journeys-api-v4-services allowlist.
export const JOURNEYS_V4_REDIRECTION_ANNUAL_REPORT = 'journeys-v4-redirection-annual-report';
export const RELEASE_ACCOUNT_SETTINGS_MFA = 'release-account-settings-mfa';
export const RELEASE_APRIL_TAX_SERVICES = 'release-april-tax-services';
export const RELEASE_APRIL_TAX_SERVICES_PHASE_2 = 'release-april-tax-services-phase-2';
export const RELEASE_BUSINESS_PROFILE_V2 = 'release-business-profile-v2';
export const RELEASE_COMPANIES_PAGE = 'release-companies-page';
export const RELEASE_FINANCE_HUB = 'release-finance-hub';
export const RELEASE_SQUARESPACE_DOMAINS_RESELLER = 'release-squarespace-domains-reseller';
export const RELEASE_SQUARESPACE_WEBSITES_RESELLER = 'release-squarespace-websites-reseller';
export const RELEASE_VELO_ORDER_STATUS = 'release-velo-order-status';
export const SHOW_DOWNLOAD_RECEIPTS = 'show-download-receipts';
export const SHOW_ORPHAN_ACCOUNT_OPTIONS = 'show-orphan-account-options';
export const VELO_REPLACE_NEXT_UP_CARDS = 'velo-replace-next-up-cards';
export const WFC_PAST_DUE_BANNER_CTA_EXPERIMENT = 'wfc-past-due-banner-cta-experiment';
